import { createRouter, createWebHistory } from 'vue-router'

//user views
import HomeView from '../views/user/HomeView.vue'
import LoginView from '../views/user/LoginView.vue'
import RegisterView from '../views/user/RegisterView.vue'
import MembershipTerms from '../views/user/MembershipTerms.vue'
import ParkingPassWaitingRegView from '../views/user/ParkingPassWaitingRegView.vue'
import TicketResult from '../views/user/TicketResult.vue'
import TicketResultPersonal from '../views/user/TicketResultPersonal.vue'
import UserInfoEditView from '../views/user/UserInfoEditView.vue'
import ParkingAreaInfoView from '../views/user/ParkingAreaInfoView.vue'
import NoticeView from '../views/user/NoticeView.vue'

//admin views
import AdminLoginView from '../views/admin/AdminLoginView.vue'
import AdminDashboardView from '../views/admin/AdminDashboardView.vue'
import UserManagementView from '../views/admin/UserManagementView.vue'
import AdminParkingAreaView from '../views/admin/AdminParkingAreaView.vue'
import AdminParkingPassWaitingView from '../views/admin/AdminParkingPassWaitingView.vue'
import AdminParkingPassChangeView from '../views/admin/AdminParkingPassChangeView.vue'
import AdminActiveParkingPassView from '../views/admin/AdminActiveParkingPassView.vue'
import AdminActiveParkingPassChangeHistory from '../views/admin/AdminActiveParkingPassChangeHistory.vue'
import AdminTicketWinner from '../views/admin/AdminTicketWinner.vue'
import AdminParkingPassLotteryLoser from '../views/admin/AdminParkingPassLotteryLoser.vue'
import AdminDiscountView from '../views/admin/AdminDiscountView.vue'
import AdminTestDataInsertView from '../views/admin/AdminTestDataInsertView.vue'
import AdminCommonSetting from '../views/admin/AdminCommonSetting.vue'
import AdminApiTestView from '../views/admin/AdminApiTestView.vue'
import AdminNoticeView from '../views/admin/AdminNoticeView.vue'
import EbppTest from '../views/admin/EbppTest.vue'

//결제관련
import SmartRoSuccessView from '@/views/user/smartro_pay_success.vue'; 
import SmartRoFailView from '@/views/user/smartro_pay_fail.vue';
import PaymentView from '../views/user/PaymentView.vue'
import AdminPaymentResultView from '../views/admin/AdminPaymentResultView.vue'
import AdminPaymentCancelView from '../views/admin/AdminPaymentCancelView.vue'
import AdminPaymentFailResultView from '../views/admin/AdminPaymentFailResultView.vue'

const routes = [
  // 일반 사용자
  { path: '/', name: 'home', component: HomeView },
  { path: '/login', name: 'login', component: LoginView },
  { path: '/membership-terms', name: 'membershipTerms', component: MembershipTerms },
  { path: '/register', name: 'register', component: RegisterView },
  {
    path: '/parking-pass-waiting-reg',
    name: 'parkingPassWaitingReg',
    component: ParkingPassWaitingRegView,
    meta: { requiresUser: true }
  },
  {
    path: '/ticket-result',
    name: 'ticketResult',
    component: TicketResult,
    meta: { requiresUser: true }
  },
  {
    path: '/ticket-result-personal',
    name: 'ticketResultPersonal',
    component: TicketResultPersonal,
    meta: { requiresUser: true }
  },
  {
    path: '/user-info-edit',
    name: 'userInfoEdit',
    component: UserInfoEditView,
    meta: { requiresUser: true }
  },
  {
    path: '/payment',
    name: 'payment',
    component: PaymentView
  },
  {
    path: '/parking-area-info',
    name: 'parkingAreaInfo',
    component: ParkingAreaInfoView
  },
  {
    path: '/notices',
    name: 'notices',
    component: NoticeView
  },

  // 관리자
  { path: '/admin/login', name: 'adminLogin', component: AdminLoginView },
  {
    path: '/admin/dashboard',
    name: 'adminDashboard',
    component: AdminDashboardView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/api-test',
    name: 'adminApiTest',
    component: AdminApiTestView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/ebpp-test',
    name: 'adminEbppTest',
    component: EbppTest,
    meta: { requiresAdmin: true }
  },
  {
    path: '/SmartRoSuccessView',
    name: 'smartroPaySuccess',
    component: SmartRoSuccessView
  },
  {
    path: '/SmartRoFailView',
    name: 'smartroPayFail',
    component: SmartRoFailView
  },  
  {
    path: '/admin/users',
    name: 'adminUsers',
    component: UserManagementView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/parking-area',
    name: 'adminParkingArea',
    component: AdminParkingAreaView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/parking-pass-waiting',
    name: 'adminParkingPassWaiting',
    component: AdminParkingPassWaitingView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/parking-pass-change',
    name: 'adminParkingPassChange',
    component: AdminParkingPassChangeView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/active-parking-pass',
    name: 'adminActiveParkingPass',
    component: AdminActiveParkingPassView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/active-parking-pass-change-history',
    name: 'adminActiveParkingPassChangeHistory',
    component: AdminActiveParkingPassChangeHistory,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/ticket-winner',
    name: 'adminTicketWinner',
    component: AdminTicketWinner,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/lottery-loser',
    name: 'adminLotteryLoser',
    component: AdminParkingPassLotteryLoser,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/discount',
    name: 'adminDiscount',
    component: AdminDiscountView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/common-setting',
    name: 'adminCommonSetting',
    component: AdminCommonSetting,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/notices',
    name: 'adminNotices',
    component: AdminNoticeView,
    meta: { requiresAdmin: true }
  }
  ,{
    path: '/admin/test-data-insert',
    name: 'adminTestDataInsert',
    component: AdminTestDataInsertView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/payment-result',
    name: 'adminPaymentResult',
    component: AdminPaymentResultView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/payment-cancel',
    name: 'adminPaymentCancel',
    component: AdminPaymentCancelView,
    meta: { requiresAdmin: true }
  },
  {
    path: '/admin/payment-fail-result',
    name: 'adminPaymentFailResult',
    component: AdminPaymentFailResultView,
    meta: { requiresAdmin: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    return { top: 0, left: 0, behavior: 'auto' }
  }
})

// 네비게이션 가드
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAdmin) {
    if (!sessionStorage.getItem('adminUser')) return next('/admin/login')
  }
  if (to.meta.requiresUser) {
    if (!sessionStorage.getItem('user')) return next('/login')
  }
  next()
})

export default router
